/* @generated from adl module ferovinum.sourcecontracts.deal */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.deal` contract.
 */
export interface DealSource {
  id: ferovinum_app_db.DealId;
  organisationId: ferovinum_app_db.OrganisationId;
  dealNumber: common_strings.StringNE;
  dealDate: common.LocalDate;
  locale: common_strings.StringNE;
  currency: common_strings.StringNE;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeDealSource(
  input: {
    id: ferovinum_app_db.DealId,
    organisationId: ferovinum_app_db.OrganisationId,
    dealNumber: common_strings.StringNE,
    dealDate: common.LocalDate,
    locale: common_strings.StringNE,
    currency: common_strings.StringNE,
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): DealSource {
  return {
    id: input.id,
    organisationId: input.organisationId,
    dealNumber: input.dealNumber,
    dealDate: input.dealDate,
    locale: input.locale,
    currency: input.currency,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const DealSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.deal","decl":{"annotations":[{"value":{"modelName":"source__app_db.deal","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.deal` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DealId"}},"parameters":[]}},{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"dealNumber","default":{"kind":"nothing"},"name":"dealNumber","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"dealDate","default":{"kind":"nothing"},"name":"dealDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"locale","default":{"kind":"nothing"},"name":"locale","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"DealSource","version":{"kind":"nothing"}}};

export const snDealSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.deal", name:"DealSource"};

export function texprDealSource(): ADL.ATypeExpr<DealSource> {
  return {value : {typeRef : {kind: "reference", value : snDealSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.deal.DealSource" : DealSource_AST
};
